import Loader from '@/components/Loader/Loader';
import { AuthService } from '@/services/auth.service';
import { isOnboardingIdentityVerificationRequired } from '@/utils/onboardingIdentityVerification';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type RequireOnboardingFinishedProps = {
  children: React.ReactNode;
};

export function RequireOnboardingFinished({
  children,
}: RequireOnboardingFinishedProps) {
  const location = useLocation();
  const identityVerificationRequired = isOnboardingIdentityVerificationRequired();

  const { data: userInfo, isPending } = useQuery({
    queryKey: ['user-info'],
    queryFn: async () => await AuthService.userInfo(),
    staleTime: 1000 * 60 * 60 * 24,
  });

  if (isPending) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <Loader />
      </div>
    );
  }

  const isFinished =
    userInfo?.onboarding_step === 'finished' ||
    (!identityVerificationRequired &&
      userInfo?.onboarding_step === 'identity_verification');

  if (!isFinished) {
    const from = location.pathname + location.search + location.hash;
    return <Navigate to="/onboarding" replace state={{ from }} />;
  }

  return <>{children}</>;
}